import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge, BadgeProps } from 'antd';

import { EAdspaceStatus } from 'entities/Adspace';

interface IAdsapceStatusProps extends BadgeProps {
	adspaceStatus?: EAdspaceStatus;
}

export const AdsapceStatus: FC<IAdsapceStatusProps> = ({ adspaceStatus, ...props }) => {
	const { t } = useTranslation();

	if (!adspaceStatus) return null;

	const statuseMap: Record<EAdspaceStatus, { status: BadgeProps['status']; text: string }> = {
		[EAdspaceStatus.NOT_VERIFIED]: {
			status: 'warning',
			text: t('Не верифицирована'),
		},
		[EAdspaceStatus.VERIFIED]: {
			status: 'success',
			text: t('Верифицирована'),
		},
		[EAdspaceStatus.VERIFYING]: {
			status: 'default',
			text: t('На верификации'),
		},
		[EAdspaceStatus.DECLINED]: {
			status: 'error',
			text: t('Отклонена'),
		},
		[EAdspaceStatus.DEACTIVATED]: {
			status: 'error',
			text: t('Отключена'),
		},
		[EAdspaceStatus.CREATING]: {
			status: 'processing',
			text: t('Создаем'),
		},
	};

	return (
		<Badge
			{...props}
			style={{ whiteSpace: 'nowrap' }}
			status={statuseMap[adspaceStatus]?.status}
			text={statuseMap[adspaceStatus]?.text}
		/>
	);
};
